import styles from "./recInnerTop.module.scss";
import { Tooltip,Menu,Dropdown } from "antd";
import { StatusTag } from "../../../../../shared/widgets/statusTag";
import React from "react";
import { URStatusDot } from "../../../../../shared/widgets/avatarGroup/statusDot";
import { URAvatarGroup } from "../../../../../shared/widgets/avatarGroup";
import statusimg from "../../../../../styles/images/profile-status-icon.svg";
import {
  gotoChat,
  makeFavourite,
  secondsToHMSConverter,
  timeStampConverter,
  userStatusColor, voiceMaillInnertopDate
} from "../../../../../base/callService/common";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { initiateCall } from "../../../../../base/callService/callService";
import { callMainWindowState } from "../../../../../models/callModel";
import { config } from "../../../../../base/constant";
import { initialStateModel } from "../../../../../models/model";
import { handleMute, unmuteNotification } from "../../../../../base/socketChatService/utils";
import { storeChatWindow } from "../../../../../base/callService/store_mining";

export default function RecInnerTop() {
  
  const { callReducer }: initialStateModel = useSelector((state: initialStateModel) => state);


  let { particularLog } = callReducer;
  console.log("particularLog",particularLog);
  
  let formatDate: any = voiceMaillInnertopDate(particularLog?.created_at).split(" ");
  const history = useHistory();
  const { callPermissionDetail}: callMainWindowState
  = useSelector((state: callMainWindowState) => state);
let { flipDeviceInfo } = callPermissionDetail || [];

  return (
    <>
      <div className={styles.topBar}><h3>Recorded Call</h3></div>

      <div className={styles.mainprofiles}>
        <div className={`${styles.profiledetails}`}>
          <div className={styles.userAvDt}>
            <URAvatarGroup className='lefts size82 noOutline'
              profileInfo={
                (particularLog?.ImageURL !== "" && particularLog?.ImageURL !== null) ?
                  <>
                    <img src={particularLog?.ImageURL} alt="" />
                    <URStatusDot className={userStatusColor(particularLog?.user_status, 'big')} /></> :
                  <>
                    <span>{particularLog?.caller_id?.charAt(0).toUpperCase()} </span>
                    <URStatusDot className={userStatusColor(particularLog?.user_status, 'big')} /></>
              } />
          </div>
          <div className={styles.userDt}>
            <p className={styles.userName} onClick={()=>storeChatWindow(particularLog)}
              title="View contact details">{particularLog?.caller_id}</p>
   
            
   <Tooltip placement="top"
              title={particularLog?.is_favourite === 1 ? "Remove Favourite" : 'Add Favourite'}>
              <span className={particularLog?.is_favourite === 1 ?
                             `icon_starfill cgreen ${styles.active} ` : 'icon_star'}
                onClick={() => makeFavourite(particularLog?.is_favourite === 0 ? 1 : 0,particularLog)}>
              </span></Tooltip>
             {(particularLog?.is_muted === 0) ?
                        <Tooltip placement="top" title={((particularLog?.is_muted === 0) )&& "Mute all notifications"}>
                            <Dropdown trigger={["click"]} overlay={ <Menu onClick={(e:any)=>handleMute(e,particularLog)}>
                            <Menu.Item key={"Until 8:00 AM"}>Until 8:00 AM</Menu.Item>
                            <Menu.Item key={"1 Hr"}>1 Hr</Menu.Item>
                            <Menu.Item  key={"12 Hr"}>12 Hrs</Menu.Item>
                            <Menu.Item key={"1 Week"}>1 Week</Menu.Item>
                            <Menu.Item key={"Always"}>Always</Menu.Item>
                            </Menu>} placement="bottomCenter"><span className={((particularLog?.is_muted === 0)) ?
                                styles.bellNotification : ` ${styles.bellNotification} ${styles.active}`}></span></Dropdown>
                        </Tooltip>
                    :
                      (particularLog?.is_muted=== 1 )&&
                      <Tooltip placement="top" title="Unmute all notifications">
                          <span onClick={()=>unmuteNotification(particularLog)} className={((particularLog?.is_muted===1 && particularLog?.sip_login_id) )?` ${styles.bellNotification} ${styles.active}`: styles.bellNotification}></span>
                        </Tooltip> }

          </div>
          <div className={styles.actionIcon}>
            <div className={styles.callIcon} onClick={() => initiateCall(particularLog?.ext, 'audio')}>
              <span></span> Call</div>
            <div className={styles.chatIcon} onClick={() =>gotoChat(particularLog, history)}>
              <span></span> Chat</div>
            <div className={styles.meetIcon}><span></span> Meet</div>
          </div>
          <div className={styles.profileDt}>
            <div className={`${styles.rowFlex} ${styles.alignItemCenter}`}>
              <div className={styles.leftsidetxt}>
                <p>Department</p>

              </div>
              <div className={styles.rightsidetxt}>
                <p>{particularLog?.department ? particularLog?.department : 'Not AVailable'}</p>
              </div>
            </div>
            <div className={`${styles.rowFlex} ${styles.alignItemCenter}`}>
              <div className={styles.leftsidetxt}>
                <p>Extension</p>
              </div>
              <div className={styles.rightsidetxt}>
                <p>{particularLog?.ext}</p>
              </div>
            </div>
            <div className={`${styles.rowFlex} `}>
              <div className={styles.leftsidetxt}>
                <p>My Numbers</p>
              </div>
              <div className={styles.rightsidetxt}>
                <div className={styles.phoneNumbrtxt}>
                  <Tooltip placement="top" title="Company Switch number"><p>442034440424</p></Tooltip>
                  <Tooltip placement="top" title="Worktual number"><p></p></Tooltip>
                  <Tooltip placement="top" title="Mobile number"><p>{particularLog?.mobileno}</p></Tooltip>
                  <Tooltip placement="top" title="International number"><p></p></Tooltip>
                </div>
              </div>
            </div>
            <div className={`${styles.rowFlex} `}>
          { particularLog?.sip_login_id&&
          <><div className={styles.leftsidetxt}>
                  <p>Active Device</p>
                </div>
                <div className={styles.rightsidetxt}>

                  {flipDeviceInfo?.length > 0 ?
                    (
                      flipDeviceInfo.map((elem: any, index: number) => {
                        return (
                          <div className={styles.deviceactive} key={index}>
                            {elem?.device_type === config().DESK_PHONE &&
                                <p><span className='icon_globe'></span> Desk Phone </p>}
                            {elem?.device_type === config().UR_ANDROID &&
                                <p><span className='icon_app'></span> Android</p>}
                            {elem?.device_type === config().UR_IOS &&
                                <p><span className='icon_app'></span> IOS </p>}
                          </div>
                        );
                      })
                    ) :(<p>Not Available</p>)
                  }
                  </div></>}
            </div>
            
            <div className={`${styles.rowFlex} `}>
              <div className={styles.leftsidetxt}>
                <p>Email</p>
              </div>
              <div className={styles.rightsidetxt}>
                <div className={styles.emailtxt}>
                  <Tooltip placement="top" title={particularLog?.email_id}>
                    <p>{particularLog?.email_id}</p></Tooltip>
                  {/* <Tooltip placement="top" title="johnywade.12465@vectone.com">
                    <p>johnywade.johny.wa@vectone.com</p></Tooltip> */}
                </div>
              </div>
            </div>
          </div>
          <div className={styles.workingStatus}>
            <StatusTag className='statusTag bgGrey' name='Working remotely' />
            <span><img src={statusimg} alt="" /></span>
          </div>
        </div>
      </div>
      {
        formatDate[0] !== "undefined" && <div className={styles.actionDetailsIcon}>
          <span className="icon_datepick"></span>
          <span>{timeStampConverter(particularLog?.created_at,'group')}</span>
          <span className="icon_clock"></span>
          <span>{`${formatDate[2]} ${formatDate[3]}`}</span>
          <span className="icon_timer"></span>
          <span>{secondsToHMSConverter(particularLog?.recording_duration)}</span>
        </div>
      }
    </>
  );
};